import { Box, Button, Flex } from '@chakra-ui/react';
import { useCallback, useState } from 'react';

import { Level } from '@app/api/models/structure';
import { Dialog, Txt } from '@app/components/common';
import { useAlert, useApi } from '@app/hooks';
import { QueryDraggableTable } from '@app/components/common/table';

export const DragSubmit = ({
  open,
  onClose,
  dragValues,
}: { open: boolean, onClose(): void, dragValues: { updatedArray: Level[], oldIndex: number, newIndex: number} }) => {
  const { info, error } = useAlert();
  const api = useApi();
  const { refetch } = QueryDraggableTable.useQueryTable();
  const [loading, setLoading] = useState(false);

  
  const onDragSubmit = useCallback(async () => {
    const { updatedArray } = dragValues;
    if (!updatedArray) {return;}
    setLoading(true);

    const sorted = [...updatedArray].sort((a, b) => b.value - a.value);

    const changes: Level[] = updatedArray.reduce((acc, { id, name }, index) => {
      if (sorted[index].name !== name) {
        acc.push({ 
          id: sorted[index].id, 
          name: acc.length === 0 ? name + ' ' : name,
          value: sorted[index].value, 
          is_active: sorted[index].is_active 
        });
      }
      return acc;
    }, []);

    if (changes.length === 0) {
      setLoading(false);
      onClose();
      return;
    }

    changes.push({ 
      id: changes[0].id, 
      name: changes[0].name.trim(), 
      value: changes[0].value, 
      is_active: changes[0].is_active 
    });

    let success = true;
    for (const item of changes) {
      const response = await api.structure.updateLevel(item);
      if (response.code !== 200) {
        success = false;
        break;
      }
    }
    

    await refetch();
    setLoading(false);
    if (success) {
      info('Изменения успешно применены');
      onClose();
    }
  }, [dragValues, refetch, onClose, api.structure, info]);

  const onCancel = async () => {
    refetch();
    onClose();
  };

  return <Dialog open={open}
    loading={loading}
    actions={<Flex justifyContent="space-between" flex={1}>
    <Button colorScheme='green' onClick={onDragSubmit}>Применить</Button>
    <Button variant='ghost' onClick={onCancel}>Отмена</Button>
  </Flex>}
    onClose={onCancel}
    title="Применение изменений"
    width={400}
  >
  <Box display='flex' flexDirection='column' gap={4}>
    <Txt>Применить изменения уровня?</Txt>
  </Box>
</Dialog>;
};